// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__2btld","gradentText":"style_gradentText__3Dxle"};